import {
  GET_ALL_CURRENCY_REQUEST,
  GET_ALL_CURRENCY_SUCCESS,
  GET_ALL_CURRENCY_FAILURE,
} from "./ActionType";

const initialState = {
  currencies: [],
  loading: false,
  error: "",
};

export const publicCurrencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CURRENCY_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_CURRENCY_SUCCESS:
      return { ...state, loading: false, error: "", currencies: action.payload };

    case GET_ALL_CURRENCY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
